module.exports = __webpack_public_path__ + "static/startups-slider-1-8af1f24d666985228b63e404dd2fb20a.png";